import React from "react"
import Container from "@ecom/ui/components/Container"
import clsx from "clsx"
import { StaticImage } from "gatsby-plugin-image"

import * as styles from "./percentsReturnsRedesign.module.scss"

type PersentReturnProps = {
  orderNum?: string
  returnPrecentTitle?: React.ReactNode
  returnPrecentDescr?: React.ReactNode
  secondSection?: boolean
}

export const PercentsReturnsRedesign = ({
  orderNum,
  returnPrecentTitle,
  returnPrecentDescr,
  secondSection = false,
}: PersentReturnProps) => (
  <section
    className={clsx(styles.section, secondSection && styles.secondSection)}
    data-exclude={orderNum}
  >
    <Container
      className={clsx(
        styles.container,
        secondSection && styles.secongContainer
      )}
    >
      <div className={clsx(styles.wrap, secondSection && styles.secondWrap)}>
        <div className={styles.textBlock}>
          <h2 className={styles.title}>{returnPrecentTitle}</h2>
          <ul className={styles.ulCls}>{returnPrecentDescr}</ul>
        </div>
        {secondSection ? (
          <div className={styles.secondImage}>
            <StaticImage
              alt="Выбирайте Совкомбанк"
              src="../../images/VygodnayaStavkaRedesign/percentsReturns/choiceSovcombank.png"
              placeholder="blurred"
              formats={["auto", "webp", "avif"]}
            />
          </div>
        ) : (
          <StaticImage
            className={styles.img}
            alt="Возвращение процентов"
            src="../../images/VygodnayaStavkaRedesign/percentsReturns/percentReturn.png"
            placeholder="blurred"
            formats={["auto", "webp", "avif"]}
          />
        )}
      </div>
    </Container>
  </section>
)
